import Box from '@mui/material/Box';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { desktopButtonStyle, desktopSecondaryButtonStyle } from '../../../../constants';
import IconMessage, { IconMessageIcon } from '../../../../components/IconMessage';

interface EmptyResultDashboardtProps {
    title: string;
    subtitle: string;
    buttonText?: string;
    action?: () => void;
  } 

const EmptyResultDashboard = ({ 
    title,
    subtitle,
    buttonText,
    action

    }: EmptyResultDashboardtProps ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  return (
    
        <Box sx={{ width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center' }}>
          <IconMessage 
            icon={IconMessageIcon.SEARCH_WARNING}  title={title}
            subtitle={subtitle}  />
            {buttonText && <Button variant="contained" sx={{ desktopButtonStyle }} onClick={action}>
              {buttonText}
            </Button>}
        </Box>
  )
       
};

export default EmptyResultDashboard;
